import { ChevronLeft, Trash2 } from "lucide-react"
import { useDeleteThreadMutation } from "../../../../redux/queries/conversations"
import { toggleCurrentThreadDetailsView } from "../../../../redux/slices/conversations"
import { Thread } from "../../../../types"
import { useAppDispatch } from "../../../hooks"
import { LinkBtn } from "../../buttons"
import InitialsAvatar from "../../initials-avatar"
import { Link } from "react-router-dom"

interface Props {
  thread: Thread
}

const Header = ({ thread }: Props) => {
  const dispatch = useAppDispatch()

  const initials = `${thread.first_name[0]}${thread.last_name[0]}`

  const toggleDetailsView = () => {
    dispatch(toggleCurrentThreadDetailsView())
  }

  const [deleteThread, { isLoading: isDeletingThread }] =
    useDeleteThreadMutation()

  const handleDeleteThread = () => {
    const shouldDeleteThread = window.confirm(
      "Are you sure you want to delete this thread?"
    )
    if (shouldDeleteThread) deleteThread({ threadId: thread._id })
  }

  return (
    <div className="sticky top-0 px-6 py-3 bg-white">
      <div>
        <Link
          to="/conversations"
          className="bg-neutral-100 rounded-lg md:hidden pl-1 pr-2 py-1 h-8 inline-flex items-center mb-4"
        >
          <ChevronLeft size={24} aria-hidden="true" />
          Back
        </Link>
      </div>
      <div className="flex items-center">
        <h3 className="flex items-center">
          <InitialsAvatar initials={initials} />
          <span className="ml-2">
            {thread.first_name} {thread.last_name}
          </span>
        </h3>

        <LinkBtn
          onClick={toggleDetailsView}
          text="base"
          className="ml-auto hover:no-underline !px-2"
          disabled={isDeletingThread}
        >
          Lead Details
        </LinkBtn>

        <LinkBtn
          onClick={handleDeleteThread}
          className="ml-1 md:ml-2 hover:no-underline !px-2"
          disabled={isDeletingThread}
        >
          <Trash2 size={16} aria-hidden="true" />
          <span className="sr-only">Delete conversation</span>
        </LinkBtn>
      </div>
    </div>
  )
}

export default Header
